@if (isLoading) {
  <div style="height: 150px; margin-top: 100px;" fxLayoutAlign="center center">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
@if (!isLoading) {
  <div fxLayout="column" class="content" style="height: 100%;">
    <div style="height: 90%;">
      @if (!isDuplicar) {
        <div fxLayout="column" >
          <span class="title">Configuração do Projeto</span>
          <span class="subtitle">
            Dê nome e escolha uma imagem para representar este projeto. Você também pode escolher o
            dono do projeto
          </span>
        </div>
      }
      @if (isDuplicar) {
        <div fxLayout="column" >
          <span class="title">Criar nova versão anual</span>
          <span class="subtitle">
            Altere os dados e informações que precisar. <br/>
            <strong>Importante:</strong> Ao alterar o título do projeto as versões anteriores também serão renomeadas.
          </span>
        </div>
      }
      <form fxLayout="row" fxLayoutGap="20px" [formGroup]="form" style="padding-top: 20px;">
        <div [fxFlex]="!fullWidth ? 33.33 : 50" >
          <div fxLayout="column" fxLayoutGap="20px">
            <mat-form-field>
              <mat-label>Nome do Projeto</mat-label>
              <input formControlName="descricao" matInput type="text">
              <button matSuffix mat-icon-button aria-label="Clear">
                <mat-icon>close</mat-icon>
              </button>
              @if (form.get('descricao')?.hasError('required')) {
                <mat-error>
                  Este campo é obrigatório
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div [fxFlex]="!fullWidth ? 33.33 : 50">
          <div fxLayout="column" fxLayoutGap="20px">
            <mat-form-field>
              <mat-select placeholder="Escolher Dono do Projeto" formControlName="user">
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Buscar" noEntriesFoundLabel="Nenhum usuário encontrado"
                    [formControl]="tagFilterCtrl">
                  </ngx-mat-select-search>
                </mat-option>
                @for (tag of filteredTags | async; track tag) {
                  <mat-option [value]="tag">
                    {{tag.displayName}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (submitProjectObj.responsavel && submitProjectObj.responsavel.id > 0) {
            <app-user-profile-card [userData]="submitProjectObj.responsavel"
              [showPermissionList]="true">
            </app-user-profile-card>
          }
        </div>
        <div [fxFlex]="50">
          <div fxLayout="column" fxLayoutGap="20px">
            <mat-form-field>
              <mat-label>Ano de Referência do Projeto</mat-label>
              <input formControlName="dataAnoRef" matInput type="number" mask="9999">
            </mat-form-field>
            @if (form.get('dataAnoRef')?.hasError('required')) {
              <mat-error>
                Este campo é obrigatório
              </mat-error>
            }
          </div>
        </div>
      </form>
      <form class="body-height body-content" fxLayout="row" [formGroup]="form">
        <!-- NOVOOOO-->
        <div [fxFlex]="!fullWidth ? 33.33 : 33">
          <div fxLayout="column" fxLayoutGap="20px">
            <div appDragDrop class="pointer" (onFileDropped)="uploadFile($event)" fxLayout="column"
              fxLayoutAlign="center center" fxLayoutGap="4rem" id="no-file-box" (click)="fileInput.click()">
              @if (imagePreview.fileType.length === 0 && !project.pathCapa) {
                <div fxLayout="column" fxLayoutAlign="center center">
                  <span class="material-icons icon">
                    photo_camera
                  </span>
                </div>
              }
              <input hidden type="file" multiple #fileInput (change)="uploadFile($event.target.files)">
              @if (imagePreview.fileType.length > 0) {
                <div fxLayoutAlign="center center">
                  <img [src]="'data:image/'+imagePreview.fileType+';base64,'+imagePreview.base64" alt="preview da imagem">
                </div>
              }
              @if (imagePreview.fileType.length === 0 && project.pathCapa && project.pathCapa.length > 0) {
                <div
                  fxLayoutAlign="center center">
                        <img [src]="storageUrl + 'projetos/' + project.id + '/capa?t=' + timestamp" alt="imagem no projeto">
                    </div>
}

                </div>
            </div>
        </div>

        <div [fxFlex]="70" class="divEditor">
            <mat-label style="margin-left: 10px; margin-bottom: 10px;">Descrição</mat-label>
            <div fxLayout="column">
                <mat-quill 
                        #matQuillEditor
                        [modules]="quillConfiguration"  
                        [placeholder]="''" 
              formControlName="resumoHtml"
              format="html"
              [styles]="editorStyle"
              style="padding-top: 0px;">
            </mat-quill>
          </div>
        </div>
        <!-- NOVOOOO-->
      </form>
    </div>
    <div fxLayout="row" [fxLayoutAlign]="!fullWidth ? 'space-between center' : 'end center'" class="footer-height">
      <app-button [txt]="!fullWidth ? 'VOLTAR' : 'CANCELAR'" [class]="!fullWidth ? 'border-blue' : 'no-border'" (click)="!fullWidth ? goTo('prev') : dismiss()"> </app-button>
      <app-button [txt]="!fullWidth ? 'FINALIZAR' : 'SALVAR'" [isDisabled]="!form.valid" [class]="'border-blue-filled'" (click)="goTo('next')"> </app-button>
    </div>
  </div>
}
